import React from "react";
import ReactDOM from "react-dom";
import { ErrorBoundary } from "react-error-boundary";
import { CannyChangelogOptions, CannyRenderOptions } from "@lifeat/shared/canny/CannyTypes";
import * as Sentry from "@sentry/react";
import { Analytics } from "@vercel/analytics/react";
import App from "./app/App";
import { handleGlobalAppError } from "./app/ErrorBoundary/ErrorBoundaryHandler";
import GlobalErrorFallback from "./app/ErrorBoundary/GlobalErrorFallback";

declare global {
    interface Window {
        adsbygoogle: any;
        google: any;
        todesktop: any;
        CRISP_WEBSITE_ID: any;
        $crisp: any;
        gtag: any;
        Rewardful?: {
            referral: string;
        };
        Canny(a: "render", options: CannyRenderOptions): void;
        Canny(
            a: "initChangelog",
            options: {
                appID: string;
            } & CannyChangelogOptions,
        ): void;
    }
}

Sentry.init({
    dsn: process.env.SENTRY_DSN,
    sampleRate: 0.3,
    integrations: [],
});

const app = (
    <React.StrictMode>
        <ErrorBoundary FallbackComponent={GlobalErrorFallback} onError={handleGlobalAppError}>
            <App />
            <Analytics />
        </ErrorBoundary>
    </React.StrictMode>
);

ReactDOM.render(app, document.getElementById("app"));
